import {createSlice} from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/logEvents/LogEventsUIHelpers";

const initialLogEventsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  queryParams: initialFilter,
  sources: [],
  levels: []
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const logEventsSlice = createSlice({
  name: "logEvents",
  initialState: initialLogEventsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    sourcesFetched: (state, action) => {
      state.listLoading = false;
      state.sources = action.payload.sources.map(x => {
        return {value: x.id, label: x.name}
      });
      state.error = null;
    },
    levelsFetched: (state, action) => {
      state.listLoading = false;
      state.levels = action.payload.levels.filter(x => x.description !== "DEBUG").map(y => {
        return {value: y.id, label: y.description}
      });
      state.error = null;
    },
    // findLogEvents
    logEventsFetched: (state, action) => {
      const { totalCount, entities, pageSize, pageNumber } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.queryParams.pageSize = pageSize;
      state.queryParams.pageNumber = pageNumber;
      state.movementForEdit = undefined;
    },
    // Pagination
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateQueryParamsAndReset: (state, action) => {
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
  }
});
